module.exports = __webpack_public_path__ + "media/customizations/growfield/back-756e957a7104570762cfb2ce7f969ea2.jpg";